/**
 * Studios running on Applates today.
 *
 * The two barbershops (קאסם פרג׳, מספרת סטאציו) lead the /salons page's
 * strip instead; see landings/salons.js.
 */

export const customers = [
  { name: "WeFit", logo: require("@/assets/WeFit.jpg") },
  { name: "סטודיו לליאן", logo: require("@/assets/StudioLelian.jpg") },
  { name: "סטודיו יארא", logo: require("@/assets/StudioYara.jpg") },
  { name: "סאמיה פיטנס", logo: require("@/assets/samya.jpg") },
  { name: "וונדר וומן", logo: require("@/assets/WonderWoman.jpg") },
  { name: "Studio Pilara", logo: require("@/assets/pilara.jpg") },
  { name: "Awan Fit", logo: require("@/assets/awan.jpg") },
];
